const initialSpinnerShow = should_show => {
	const loading_spinner = document.getElementById("loading-spinner")

	if(!loading_spinner){
		return
	}

	console.log('initialSpinnerShow', should_show)

	if(should_show){
		loading_spinner.classList.remove('hidden')
	} else {
		loading_spinner.classList.add('hidden')
	}
}


export default initialSpinnerShow
